module.exports = __webpack_public_path__ + "static/img/图层11.82d4fa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层11.png
// module id = GVmE
// module chunks = 0